import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const PdfIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 30 34" {...props}>
      <path
        d="M2.25022 0H20.3052L29.8752 9.53278V31.875C29.8752 33.049 28.9232 34 27.7502 34H2.25022C1.07719 34 0.125244 33.049 0.125244 31.875V2.12498C0.125244 0.950958 1.0773 0 2.25022 0Z"
        fill="#E2574C"
      />
      <path
        d="M29.8442 9.56273H22.4375C21.2644 9.56273 20.3125 8.61078 20.3125 7.43775V0.0214844L29.8442 9.56273Z"
        fill="#B53629"
      />
      <path
        d="M21.904 16.1106C22.26 16.1106 22.4342 15.8004 22.4342 15.4997C22.4342 15.1884 22.2525 14.8877 21.904 14.8877H19.8767C19.4804 14.8877 19.2594 15.216 19.2594 15.5783V20.5604C19.2594 21.0045 19.5123 21.251 19.8544 21.251C20.1945 21.251 20.4484 21.0045 20.4484 20.5604V19.193H21.6746C22.0549 19.193 22.2451 18.8816 22.2451 18.5725C22.2451 18.2697 22.0549 17.9689 21.6746 17.9689H20.4484V16.1106H21.904ZM15.0519 14.8877H13.5687C13.166 14.8877 12.8801 15.164 12.8801 15.574V20.5646C12.8801 21.0735 13.2913 21.233 13.5856 21.233H15.1422C16.9845 21.233 18.2011 20.0207 18.2011 18.1495C18.2001 16.1712 17.0548 14.8877 15.0519 14.8877ZM15.1232 20.0026H14.2189V16.1181H15.0339C16.2675 16.1181 16.804 16.9458 16.804 18.088C16.804 19.1569 16.277 20.0026 15.1232 20.0026ZM9.68951 14.8877H8.22009C7.80464 14.8877 7.573 15.1618 7.573 15.5783V20.5604C7.573 21.0045 7.83861 21.251 8.19557 21.251C8.55254 21.251 8.81815 21.0045 8.81815 20.5604V19.1058H9.73931C10.8762 19.1058 11.8144 18.3004 11.8144 17.0052C11.8145 15.7377 10.9093 14.8877 9.68951 14.8877ZM9.66511 17.9371H8.81826V16.0575H9.66511C10.1879 16.0575 10.5204 16.4655 10.5204 16.9978C10.5193 17.5292 10.1879 17.9371 9.66511 17.9371Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default PdfIcon;
